<style>
  #MyListMenu li{
    cursor: pointer;
    list-style: none;
    font-size: 16px;
  }
  .Lvl2{
    margin: 10px 20px;
  }
</style>

<div class="col-md-12 mb-30" [hidden]="Switcher_View!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 *ngIf="Data_Seleted_ShowList.id==0" class="card-title border-0 pb-0">اطلاعات  کمیت ها </h5>
     <h5 *ngIf="Data_Seleted_ShowList.id>0" class="card-title border-0 pb-0">اطلاعات  زیر کمیت های '{{Data_Seleted_ShowList.title}}' </h5>
     <br/>
     <br/>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">عنوان</label>
        <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
    </div>
     <div class="row">
      <div  class="form-group col-md-12" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_Quantity()" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <button *ngIf="!Procssing" (click)="openModal_Add(templateFormAdd)" type="button"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>
        <button (click)="Back_Group()" *ngIf="!Procssing && Data_Seleted_ShowList.id>0" type="button" style="margin-left: 5px;" class="btn btn-danger"><i class="fa fa-mail-reply"></i> نمایش کمیت </button>
        <button (click)="set_Switcher_View('Tree')"  type="button" class="btn btn-warning"><i class="fa fa-outdent"></i> نمایش درختی </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>عنوان</th>
              <th *ngIf="Data_Seleted_ShowList.id>0">محدوده</th>
              <th>تاریخ</th>
              <th>کاربر</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Quantity
            |filter:Filter_title:'title'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Quantity|filter:Filter_title:'title').length
                      }
            ">
             <td>{{DataList_Quantity.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td *ngIf="Data_Seleted_ShowList.id>0">
                <p *ngIf="item.domain" style="color: #489b39;">بهفا</p>
                <p *ngIf="!item.domain" style="color: crimson;">غیر بهفا</p>
              </td>
              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" class="dropdown-item" (click)="openModal_Edi(templateFormEdit,item)"><i class="fa fa-edit"></i> ویرایش </a>
                        <a *ngIf="Data_Seleted_ShowList.id==0" style="cursor: pointer;" class="dropdown-item" (click)="Show_SubGroup(item)"><i class="fa fa-eye"></i> زیر کمیت ها </a>
                        <a *ngIf="Data_Seleted_ShowList.id==0" style="cursor: pointer;" class="dropdown-item" (click)="Show_ControllerForm(item)"><i class="fa fa-address-book"></i> مسئول فنی </a>
                        <a  style="cursor: pointer;" class="dropdown-item" (click)="openModal_Delete(templateDelete,item)"><i class="fa fa-remove"></i> حذف </a>


                        <a *ngIf="!item.domain && Data_Seleted_ShowList.id>0" style="cursor: pointer;" class="dropdown-item" (click)="Doamin(item)"><i class="fa fa-check"></i> دامنه بهفا </a>
                        <a *ngIf="item.domain && Data_Seleted_ShowList.id>0" style="cursor: pointer;" class="dropdown-item" (click)="Doamin(item)"><i class="fa fa-check"></i> دامنه غیر بهفا </a>
                    </div>
                </div>

                <div *ngIf="item.DeletingProccess" >
                  <img  src="assets/Loading.gif" style="width: 25px;" />
                </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_FeildTable"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<div  [hidden]="Switcher_View!='Tree'">
  <h5 class="card-title">اطلاعات کمیت ها و ریز کمیت های</h5>
  <div style="margin: 50px;">
    <button (click)="set_Switcher_View('List')" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
    <br/>
    <br/>
    <ul id="MyListMenu">
      <li></li>
      <ul>
        <li *ngFor="let item of DataList_Quantity_Parent" >
          <input  type="checkbox" (change)="Data_List_Menu_Change(DataList_Quantity_Parent.indexOf(item))" [checked]="item.del" class="Lvl2" /> <span >{{item.title}}</span>

          <ul *ngIf="item.del">
            <li  style="margin-right: 50px;" *ngFor="let itemDetail of item.child">
              <span >{{itemDetail.title}}</span>
          </li>
          </ul>

      </li>
      </ul>
    </ul>

  </div>
</div>

<div   *ngIf="Switcher_View=='Controller'">
  <app-QUANTITYController
  [inner_quantity_Record]="Data_Seleted_ShowList"
  >

  </app-QUANTITYController>
  <button (click)="Back_From_Controller_Form()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
</div>


<ng-template #templateDelete>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete.code=='0'" class="modal-title pull-left">تایید حذف اطلاعات کمیت  '{{Data_Seleted_Delete.title}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete.code!='0'" class="modal-title pull-left">تایید حذف اطلاعات زیر کمیت  '{{Data_Seleted_Delete.title}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="Delete()"> حذف اطلاعات <i class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>


<ng-template #templateFormAdd>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_ShowList.id==0" class="modal-title pull-left">فرم ثبت اطلاعات کمیت جدید</h4>
    <h4 *ngIf="Data_Seleted_ShowList.id>0" class="modal-title pull-left">فرم ثبت اطلاعات زیر کمیت جدید  '{{Data_Seleted_ShowList.title}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Add.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label *ngIf="Data_Seleted_ShowList.id==0" for="exampleInputEmail1">عنوان کمیت</label>
        <label *ngIf="Data_Seleted_ShowList.id>0" for="exampleInputEmail1">عنوان کمیت زیر</label>
        <input type="text" class="form-control" [(ngModel)]="txtGroupTitle" name="txtGroupTitle" placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" *ngIf="!Proccesing_Add" class="btn btn-success" (click)="Add()">
      ثبت اطلاعات </button>
      <img *ngIf="Proccesing_Add" src="assets/Loading.gif" style="width: 25px;" />
    <button type="button" class="btn btn-danger" (click)="modalRef_Add.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateFormEdit>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_ShowList.id==0" class="modal-title pull-left">فرم ویرایش اطلاعات کمیت   '{{Data_Seleted_Delete.title}}' </h4>
    <h4 *ngIf="Data_Seleted_ShowList.id>0" class="modal-title pull-left">فرم ویرایش اطلاعات زیر کمیت  '{{Data_Seleted_Delete.title}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Edi.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label *ngIf="Data_Seleted_ShowList.id==0" for="exampleInputEmail1">عنوان کمیت</label>
        <label *ngIf="Data_Seleted_ShowList.id>0" for="exampleInputEmail1">عنوان کمیت زیر</label>
        <input type="text" class="form-control" [(ngModel)]="txtGroupTitle" name="txtGroupTitle" placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
    <div class="row" *ngIf="Data_Seleted_Delete.id>0 && Data_Seleted_ShowList.id>0">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> نوع گواهی نامه </label>
        <select class="custom-select" [(ngModel)]="certificate_id">
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of Certificate_List" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
    </div>
    <div class="row" *ngIf="Data_Seleted_Delete.id>0 && Data_Seleted_ShowList.id>0">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> نوع ورود داده </label>
        <select class="custom-select" [(ngModel)]="dataentity_id">
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of DataEntity_List" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" *ngIf="!Proccesing_Edit" class="btn btn-info" (click)="Edit()">
      ثبت اطلاعات </button>
      <img *ngIf="Proccesing_Edit" src="assets/Loading.gif" style="width: 25px;" />
    <button type="button" class="btn btn-danger" (click)="modalRef_Edi.hide()">بستن</button>
  </div>
</ng-template>
